import apiClient from './apiClient';
import { ApiResponse } from '../../types/common';
import { AdminUser } from '../../types/user';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    username: string;
    isAdmin: boolean;
  };
}

export const login = async (credentials: LoginRequest): Promise<AdminUser> => {
  const response = await apiClient.post<ApiResponse<LoginResponse>>(
    '/auth/login',
    credentials
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '로그인에 실패했습니다.');
  }

  const { token, user } = response.data.data;

  // Check admin privileges
  const adminEmails = process.env.REACT_APP_ADMIN_EMAILS?.split(',') || [];
  const isAdmin = user.isAdmin || adminEmails.includes(user.email);

  if (!isAdmin) {
    throw new Error('관리자 권한이 필요합니다.');
  }

  return {
    id: user.id,
    email: user.email,
    username: user.username,
    isAdmin: user.isAdmin,
    token,
  };
};

export const verifyToken = async (): Promise<boolean> => {
  try {
    const response = await apiClient.get<ApiResponse<any>>('/auth/verify');
    return response.data.status === 200;
  } catch {
    return false;
  }
};
